














































































import { Component, Vue, Inject } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax';
import AbpBase from '../../../../lib/abpbase';
import Tools from '../../../../lib/tools';
import BusinessField from '../../../../components/tools/businessField.vue';
import QuickTable from "../../../../components/table/table.vue";
import SelectPerson from "../../../../components/select/selectPerson.vue";
import SelectDep from "../../../../components/select/selectDep.vue";
@Component({
	name:'projectLeaderList',
	components: {
		BusinessField,
		QuickTable,
		SelectPerson,
		SelectDep
	}
})
export default class ProjectLeaderList extends AbpBase  {
    initData:any = {
    	showModal: false,		// 弹窗显示状态
    	formLoading: false,		// 表单提交状态
    	bussinessAreas: [],		// 商业领域数据
    	searchData: {
    		OrganizationId: '',
    		Name: ''
    	},
    	columns: [
            {
            	title: '序号',
                type: 'index',
                width: 62,
                align: 'center'
            },
            {
                title: '姓名',
                key: 'name'
            },
            {
                title: '部门',
                key: 'depDisplayName'
            },
            {
                title: '业务领域',
                key: 'businessAreaDesc',
                render: (h:any, params:any) => {
                	return h('span', {
                		domProps: {
                			innerHTML: params.row.businessAreaDesc.replace(/\n/g, "<br/>")
                		}
                	})
                }
            },
            {
                title: '最高职称',
                key: 'hPosition'
            },
            {
                title: '职称专业',
                key: 'hPositionMajorField'
            },
            {
                title: '最高职称评定年月',
                key: 'hPositionDt',
                render: (h:any, params:any) => {
                	return h('span', Tools.formatDate(params.row.hPositionDt));
                }
            },
            {
                title: '项目负责人承诺书签订情况',
                key: 'projectLeaderCommit',
                render: (h:any, params:any) => {
					console.log(params.row.projectLeaderCommit)
                	return h('span', {},params.row.projectLeaderCommit?'已签订':'未签订');
                }
            },
            {
                title: '操作',
                width: 130,
                render: (h:any, params:any) => {
                	return h('span', [
                		h('Button', {
                			props: {
                				type: 'success',
                				size: 'small'
                			},
							on: {
								click: () => {
									this.formData.id = params.row.id;
									this.formData.hPosition = params.row.hPosition;
									this.formData.hPositionMajorField = params.row.hPositionMajorField;
									this.formData.hPositionDt = params.row.hPositionDt;
									this.formData.organizationId = params.row.depId;
									this.formData.businessArea = params.row.businessAreaFormat;
									this.initData.showModal = true;
								}
							}
                		}, '编辑'),
                		h('Button', {
                			props: {
                				type: 'error',
                				size: 'small'
                			},
                			style: {
                				marginLeft: '10px'
                			},
							on: {
								click: () => {
									this.handleDelete(params.row.id);
								}
							}
                		}, '删除')
                	])
                }
            }
		]
    }
    personForm:any = {
    	showModal: false,
    	form: {
    		id: ''
    	},
    	validate: {
    		id: [
				{ required: true, type: 'number', message: '请选择人员', trigger: 'change' }
			]
    	},
    	searchLoading: false,
    	submitLoading: false
    }
    formData:any = {
		id: '',							// 人员ID
		businessArea: [],				// 业务领域
		hPosition: '',					// 最高职称
		hPositionMajorField: '',		// 职称专业
		hPositionDt: '',				// 最高职称评定年月
		organizationId: 1,   			// 所在部门
		projectLeaderCommit:null,       //项目负责人承诺书签订情况
    }
    ruleValidate:any = {
    	id: [
			{ required: true, type: 'number', message: '请选择人员', trigger: 'change' }
		],
		organizationId: [
			{ required: true, type: 'number', message: '请选择部门', trigger: 'change' }
		],
    }
    GetData() {
    	(this as any).$refs.table.GetData();
    }
    async handleDelete(id:any) {
    	this.$Modal.confirm({
            title: '操作确认',
            content: '是否确认删除此项目负责人信息？',
            onOk: () => {
                Ajax.delete('/api/services/app/User/DeleteProjectLeaderAsync', {params: {Id: id}}).then((res:any)=>{
	                this.$Message.success('删除成功!');
                	this.GetData();
	            })
            }
        });
    }
    // 还原选择人员表单
    handleClearPersonForm(flog:any) {
    	if(!flog) {
    		this.personForm.showModal = false;
    		(this as any).$refs.personForm.resetFields();
    	}
    }
    // 新增人员
    async handleSubmit() {
    	(this.$refs.personForm as any).validate(async (valid:boolean)=>{
            if(valid){
            	this.personForm.submitLoading = true;
                await Ajax.post('/api/services/app/User/CreateProjectLeaderAsync', this.personForm.form).then((res:any)=>{
	                this.$Message.success('提交成功!');
	                this.personForm.submitLoading = false;
	                this.personForm.showModal = false;
                	this.GetData();
	            }).catch(() => {
	            	this.personForm.submitLoading = false;
	            })
            }
        })
    }
    // 编辑
    async handleEditSubmit() {
    	(this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
            	let areas:any = (this as any).$refs.businessArea.GetData();
            	let params:any = {};
            	for(let k in this.formData) {
            		if(k == 'hPositionDt') {
            			params[k] = Tools.formatDate(this.formData[k]);
            		}else if(k == 'businessArea') {
            			params['businessArea1'] = areas[0];
            			params['businessArea2'] = areas[1];
            		}else{
            			params[k] = this.formData[k];
            		}
            	}
            	this.initData.formLoading = true;
                await Ajax.put('/api/services/app/User/UpdateProjectLeaderAsync', params).then((res:any)=>{
	                this.$Message.success('编辑成功!');
	                this.initData.formLoading = false;
	                this.initData.showModal = false;
                	this.GetData();
	            }).catch(() => {
	            	this.initData.formLoading = false;
	            })
            }
        })
    }
    handleClearForm(flog:any) {
    	if(!flog) {
    		this.initData.showModal = false;
    		(this as any).$refs.form.resetFields();
    	}
    }
}
